import { Paper, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { LoanDetailsAccordion } from './loanDetailsAccordion';
import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { ItemDisplay } from './itemDisplay';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

const useStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid lightgray`,
    borderRadius: '16px !important',
    padding: theme.spacing(4),
  },
}));

interface LoanDetailsCardProps {
  store: IQuoteTypeStore;
  keyRatios: string;
  keyRatiosTooltip: string;
  showAccordion?: boolean;
}

export const LoanDetailsCard = observer(
  ({
    store,
    keyRatios,
    keyRatiosTooltip,
    showAccordion,
  }: LoanDetailsCardProps) => {
    const classes = useStyles();
    const calculatedFields = store.loanEconomicsStore.calculateFields();
    const color = '#34A853';

    return (
      <Paper className={classes.paper} elevation={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              justifyContent="space-between"
              style={{ paddingInline: '240px' }}
            >
              <Grid item>
                <ItemDisplay
                  label="Total Loan Amount"
                  value={formatCurrency(calculatedFields.totalLoanAmount)}
                  valueTextColor={color}
                />
              </Grid>
              <Grid item>
                <ItemDisplay
                  label="Key Ratios"
                  value={keyRatios}
                  valueTextColor={color}
                  tooltip={keyRatiosTooltip}
                />
              </Grid>
            </Grid>
          </Grid>
          {showAccordion && (
            <Grid item xs={12}>
              <LoanDetailsAccordion store={store} />
            </Grid>
          )}
        </Grid>
      </Paper>
    );
  }
);
